import { render, staticRenderFns } from "./GTNewsPortalDetail.vue?vue&type=template&id=119fc96f&scoped=true"
import script from "./GTNewsPortalDetail.vue?vue&type=script&lang=js"
export * from "./GTNewsPortalDetail.vue?vue&type=script&lang=js"
import style0 from "./GTNewsPortalDetail.vue?vue&type=style&index=0&id=119fc96f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119fc96f",
  null
  
)

export default component.exports